/* eslint-disable no-undef */
import $ from "jquery";

const add2cartrent = () => {
  const init = () => {
    handleChangeCountry();
  };

  const handleChangeCountry = () => {
    const el = {
      country: "#billing_country",
    };

    $(document).on("change", el.country, function () {
      if ($(this).val() === "NL") {
        $("#billing_state_field").hide();
      } else {
        $("#billing_state_field").show();
      }
    });
  };

  init();
};

try {
  add2cartrent();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
